<header class="o-widget__header">
  <h1 class="o-widget__heading">Meine Maßnahmen</h1>
  <p class="o-widget__subline">Aufgaben die zu erledigen sind von mir</p>
</header>
<div class="o-widget__body">
  <p>Absprung in den Workspace</p>
</div>
